import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import "./ResetPasswordUsingResetLink.scss";
import logo from "../../assets/images/logo.png";
import { useForm } from 'react-hook-form';
import workshop from "../../assets/images/workshop.png";
import masterApi from "../../services/masterApi";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
const ResetPasswordUsingResetLink = () => {
  const { register, handleSubmit, getValues, formState: { errors } } = useForm() 
  const { token } = useParams();
  const navigate = useNavigate();
  const [isValidLink,setIsValidLink]=useState(false);
  const onSubmit = async (data) => {    
    const formData = {
        ...data,  // Password fields
        token     // Add the token to the form data
    };
    const response = await masterApi.resetPasswordWithLink({ formData });
    if(response?.data?.ok){
        //toast.success("Password reset successfully. Please login again.")
        
        toast.success("Password reset successfully. Please login again.", {
          autoClose: 1000, // 1 seconds
            onClose: () => {
                navigate('../login')
            }
          });
    }else{
        console.log(response);
        toast.error("Something went wrong. Please try again later", {
          autoClose: 2000, // 1 seconds
        })
    }
    
  }
  const onReset  = () =>{
    navigate('../login')
  }
  const fetchData = async () => {
    try {
      const formData = { token };
      const response = await masterApi.validateResetPasswordLink(formData);
      if (response?.data?.ok) {
        setIsValidLink(true);
      } else {
        toast.error("The link is invalid or has expired. Please request a new password reset link.");
      }
    } catch (error) {
      console.error("Error validating token:", error);
      toast.error("An error occurred while validating the link.");
    }
  };

  useEffect(() => {
    fetchData(); // Call the function to validate the link
  }, [token]); // Include token as a dependency

  return (
    <div className="main-login-area">
      <div className="login-box">
       <div className="box-left">
       <div className="login-content-area">
          <div className="logo-area">
            <div className="logo-box">
              <div className="logo-img">
                <img src={logo} alt="" />
              </div>
              <div className="logo-heading">Scheduler</div>
            </div>
          </div>          
          
          <div className="login-input-area">
            <h2 className="heading space-between"> {isValidLink ?"CREATE NEW PASSWORD":"Invalid Reset Link"}</h2>
            {isValidLink ? (
            <form className="login-form space-between" onSubmit={handleSubmit(onSubmit)}>            
                <input
                    {...register("newpassword", { 
                      required: "New Password is required",
                      pattern: {
                      value: new RegExp(process.env.REACT_APP_PASSWORD_REGEX),
                      message:
                        "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character (!@#$&*)",
                    } })}
                    className={`input ${
                        errors.newpassword ? "form-control required" : "form-control"
                    }`}
                    type="password"
                    placeholder="New Password"
                    />
                <input
                {...register("confirmpassword", {
                    required: "Mismatched password",
                    validate: {
                    passwordEqual: (value) =>
                        value === getValues().newpassword || "Mismatched password",
                    },
                })}
                className={`input ${
                    errors.confirmpassword ? "form-control required" : "form-control"
                }`}
                type="password"
                placeholder="Confirm Password"
                />
                {errors.newpassword && (
                <div className="redColor space-between">
                    {errors.newpassword.message}
                </div>
                )}
                <div className="action-btn">
              <button className="cancel secondary-btn" onClick={onReset} >
                Cancel
              </button>
      
              <button className="save primary-btn" type="submit">              
                Submit
              </button>
              </div>
            </form>  
            ):<p>The link is invalid or has expired. Please request a new password reset link.</p>} 
          </div>
          
        </div>
       </div>
       <div className="box-right">
          <img src={workshop} alt="" />
        </div>
      </div>
      {<ToastContainer autoClose={1500} />}
    </div>
    
  );
};

export default ResetPasswordUsingResetLink;

